import React, { useState, useEffect, useCallback } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../../../../context/LoadingContext";
import { fetchData,postQuery } from "../../../Requirement/services/RequirementServices";
import AlertModal from "../../../Requirement/components/common/AlerModel";
import { jwtDecode } from "jwt-decode";
import {
  FormControl,
  TextField,
  Typography,
  Button,
  Select,
  MenuItem,
} from "@mui/material";
import { use } from "react";


const ProfileVisibility = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    country: "",
    state: "",
    pinZip: "",
    workingPhone: "",
    officePhone: "",
    address1: "",
    address2: "",
  });
  const [initialFormData, setInitialFormData] = useState(null);
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [isFormModified, setIsFormModified] = useState(false);
  const [activeUser, setActiveUser] = useState("");
  const [buyerInfo, setBuyerInfo] = useState([]);
  const [countrymaster, setCountryMaster] = useState([]);

  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });
  const { loading, setLoading } = useLoading();

  const handleModalClose = () => {
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
  };

  const validateForm = () => {
    const newErrors = {};
    const nameRegex = /^[a-zA-Z\s]{2,50}$/;
    const genderRegex = /^[a-zA-Z]{2,20}$/;
    const countryStateRegex = /^[a-zA-Z\s]{2,100}$/;
    const pinZipRegex = /^[a-zA-Z0-9]{5,10}$/;
    const phoneRegex =
      /^\+?\d{1,4}[-.\s]?\(?\d{1,3}\)?[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;

    if (!formData.firstName) {
      newErrors.firstName = "First Name is required";
    }
    // if (!formData.gender) {
    //   newErrors.gender = "Gender is required";
    // }
    if (!formData.country) {
      newErrors.country = "Country is required";
    }
    if (!formData.workingPhone) {
      newErrors.workingPhone = "Work phone is required";
    }
    if (!formData.address1) {
      newErrors.address1 = "Address 1 is required";
    }
    // if (!formData.pinZip || !pinZipRegex.test(formData.pinZip)) {
    //   newErrors.pinZip = "PIN/ZIP is required, 5-10 alphanumeric characters";
    // }

    return newErrors;
  };

  const checkIfFormModified = (currentData, initialData) => {
    if (!initialData) return false;
    return Object.keys(currentData).some(
      (key) => currentData[key] !== initialData[key]
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const newFormData = { ...prev, [name]: value };
      // Check if form is modified after updating formData
      setIsFormModified(checkIfFormModified(newFormData, initialFormData));
      return newFormData;
    });
    // Re-validate the form on change
    const newErrors = validateForm();
    setErrors(newErrors);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) { // && isFormModified
      setSubmitted(true);
      setLoading(true);
      console.log("buyerInfo##", buyerInfo);
      console.log("Form Data:", formData);
      try {
        const amtplUserID = buyerInfo[0].AMTPLUserID;

        const body = {
          target: "updateAMTPLUser",
          updateAMTPLUserInput: {
            AMTPLUserID: amtplUserID,
            EmailID: buyerInfo[0].EmailID,
            FirstName: formData.firstName || "",
            LastName: formData.lastName || "",
            Gender: formData.gender || "",
            Country: formData.country || "",
            State: formData.state || "",
            ZipCode: formData.pinZip || "",
            Phone1: formData.workingPhone || " ",
            Phone2: formData.officePhone || "",
            Address1: formData.address1 || " ",
            Address2: formData.address2 || " ",
          },
        };
        await postQuery(body);
        setModal({
          show: true,
          type: "success",
          title: "Success!",
          message: "Profile updated successfully.",
          autoClose: false,
          nextAction: () => {
            navigate("/buyer/profile");
          },
        });
      } catch (error) {
        console.error("Submission error:", error);
        setModal({
          show: true,
          type: "error",
          title: "Error!",
          message: error.message || "Failed to submit profile.",
          autoClose: false,
        });
      } finally {
        setSubmitted(false);
        setLoading(false);
      }
    }
  };

  const getBuyerInfo = useCallback(async (buyerEmail) => {
      try {
        const response = await fetchData({
          target: "listAMTPLUsers",
          userOrder: "AMTPLUserID",
          rowStart: 0,
          pageSize: 100,
          filterTerms: { EmailID: buyerEmail },
        });
        setBuyerInfo(response.items || []);
      } catch (error) {
        console.error("Error loading buyer info:", error);
        setBuyerInfo([]);
      }
    }, []);

  const loadCountries = useCallback(async () => {
    setLoading(true);
    try {
      const [allCountries] = await Promise.all([
        fetchData({
          target: "listDropDownOptions",
          userOrder: "Value",
          rowStart: 0,
          pageSize: 1000,
          filterTerms: { Type: "Country" },
        }),
      ]);
      if (allCountries.items.length > 0) {
        setCountryMaster(allCountries.items);
      } else {
        setCountryMaster([]);
      }
    } catch (error) {
      console.error("Error loading countries: ", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
     const checkUser = async () => {
          try {
            const user = await Auth.currentAuthenticatedUser();
            const token = user.signInUserSession.idToken.jwtToken;
            const decodedToken = jwtDecode(token);
            const groups = decodedToken["cognito:groups"] || [];
            if (!groups.includes("AMTPL_GLOBAL_PARTNERS")) {
              await Auth.signOut();
              navigate("/login/global-partner");
            } else {
              setActiveUser(user.attributes.email);
              getBuyerInfo(user.attributes.email);
              console.log(user,'setBuyerInfo')
            }
          } catch (error) {
            console.error("Error checking user:", error);
            await Auth.signOut();
            navigate("/login/global-partner");
          }
        };
    checkUser();
  }, [navigate, getBuyerInfo]);

  useEffect(() => {
    console.log('buyerInfo', buyerInfo)
    loadCountries();
    if (activeUser && buyerInfo.length > 0) {
      console.log("buyerInfo@@", buyerInfo[0]);
      const newFormData = {
        firstName: buyerInfo[0].FirstName || "",
        lastName: buyerInfo[0].LastName || "",
        gender: buyerInfo[0].Gender || "",
        country: buyerInfo[0].Country || "",
        state: buyerInfo[0].State || "",
        pinZip: buyerInfo[0].ZipCode || "",
        workingPhone: buyerInfo[0].Phone1 || "",
        officePhone: buyerInfo[0].Phone2 || "",
        address1: buyerInfo[0].Address1 || " ",
        address2: buyerInfo[0].Address2 || "",
      };
      setFormData(newFormData);
      setInitialFormData(newFormData); // Store initial form data
      // Validate form when buyerInfo is loaded
      // const newErrors = validateForm();
      // setErrors(newErrors);
      setIsFormModified(false); // Reset modification state on initial load
    }
  }, [activeUser, buyerInfo, loadCountries]);

  return (
    <div className="container mt-4">
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <div className="card p-4">
        <div className="table-header">
          <div className="header-text">
            <div className="head-text">Profile & Visibility Details</div>
          </div>
          <div className="head-btn">
            <div className="submit-btn-form">
              <Button
                type="submit"
                variant="contained"
                color="primary"
                form="questionForm"
                // disabled={
                //   submitted ||
                //   loading ||
                //   !isFormModified ||
                //   Object.keys(errors).length > 0
                // }
                onClick={handleSubmit}
              >
                {submitted || loading ? "Submitting..." : "Submit"}
              </Button>
            </div>
          </div>
        </div>
        <form id="questionForm" className="row g-2">
          <div className="col-md-4">
            <FormControl fullWidth>
              <Typography variant="body2">First Name <span className="mandatory">*</span></Typography>
              <TextField
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder="First Name"
                inputProps={{ "aria-label": "First Name" }}
                error={!!errors.firstName}
                helperText={errors.firstName}
              />
            </FormControl>
          </div>
          <div className="col-md-4">
            <FormControl fullWidth>
              <Typography variant="body2">Last Name</Typography>
              <TextField
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder="Last Name"
                inputProps={{ "aria-label": "Last Name" }}
                error={!!errors.lastName}
                helperText={errors.lastName}
              />
            </FormControl>
          </div>
          <div className="col-md-4">
            <FormControl fullWidth>
              <Typography variant="body2">Gender</Typography>
              <Select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                displayEmpty
                sx={{ backgroundColor: "white" }}
                inputProps={{ "aria-label": "Select Gender" }}
                error={!!errors.gender}
              >
                <MenuItem value="" disabled>
                  Select gender
                </MenuItem>
                <MenuItem value="M">Male</MenuItem>
                <MenuItem value="F">Female</MenuItem>
                <MenuItem value="O">Other</MenuItem>
              </Select>
              {errors.gender && (
                <Typography variant="caption" color="error">
                  {errors.gender}
                </Typography>
              )}
            </FormControl>
          </div>
          <div className="col-md-4">
            <FormControl fullWidth>
              <Typography variant="body2">Country <span className="mandatory">*</span></Typography>
              <Select
                name="country"
                value={formData.country}
                onChange={handleChange}
                displayEmpty
                sx={{ backgroundColor: "white" }}
                inputProps={{ "aria-label": "Select Country" }}
                error={!!errors.country}
              >
                <MenuItem value="" disabled>
                  Select country
                </MenuItem>
                {countrymaster.map((p) => (
                  <MenuItem key={p.ID} value={p.Value}>
                    {p.Value}
                  </MenuItem>
                ))}
              </Select>
              {errors.country && (
                <Typography variant="caption" color="error">
                  {errors.country}
                </Typography>
              )}
            </FormControl>
          </div>
          <div className="col-md-4">
            <FormControl fullWidth>
              <Typography variant="body2">State</Typography>
              <TextField
                name="state"
                value={formData.state}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder="State"
                inputProps={{ "aria-label": "State" }}
                error={!!errors.state}
                helperText={errors.state}
              />
            </FormControl>
          </div>
          <div className="col-md-4">
            <FormControl fullWidth>
              <Typography variant="body2">PIN/ZIP</Typography>
              <TextField
                name="pinZip"
                value={formData.pinZip}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder="PIN/ZIP"
                inputProps={{ "aria-label": "PIN/ZIP" }}
                error={!!errors.pinZip}
                helperText={errors.pinZip}
              />
            </FormControl>
          </div>
          <div className="col-md-4">
            <FormControl fullWidth>
              <Typography variant="body2">Working Phone <span className="mandatory">*</span></Typography>
              <TextField
                name="workingPhone"
                value={formData.workingPhone}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder="Working Phone"
                inputProps={{ "aria-label": "Working Phone" }}
                error={!!errors.workingPhone}
                helperText={errors.workingPhone}
              />
            </FormControl>
          </div>
          <div className="col-md-4">
            <FormControl fullWidth>
              <Typography variant="body2">Office Phone</Typography>
              <TextField
                name="officePhone"
                value={formData.officePhone}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder="Office Phone"
                inputProps={{ "aria-label": "Office Phone" }}
                error={!!errors.officePhone}
                helperText={errors.officePhone}
              />
            </FormControl>
          </div>
          <div className="col-md-6">
            <FormControl fullWidth>
              <Typography variant="body2">Address 1 <span className="mandatory">*</span></Typography>
              <TextField
                name="address1"
                value={formData.address1}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder="Address"
                inputProps={{ "aria-label": "Address 1" }}
                error={!!errors.address1}
                helperText={errors.address1}
              />
            </FormControl>
          </div>
          <div className="col-md-6">
            <FormControl fullWidth>
              <Typography variant="body2">Address 2</Typography>
              <TextField
                name="address2"
                value={formData.address2}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder="Address"
                inputProps={{ "aria-label": "Address 2" }}
                error={!!errors.address2}
                helperText={errors.address2}
              />
            </FormControl>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProfileVisibility;
